module.exports = __webpack_public_path__ + "static/media/more.c93e3592.svg";